import mod_examen from "@/store/mods/clinique/examens.js"
import mod_prestation from "@/store/mods/clinique/prestations.js"

export default {
    name: 'm-examen',
    components: {},
    props: {
        user_id: Number,
        info_patient: Object,
        info_caissier: Object,
        refresh_state: Number,
        is_proforma: Boolean,
        proforma_id: Number,
        can_add_differential_computing: Object,
        format_ref_facture: String,
        selected_slug: String
    },
    data() {
        return {
            one_is_checked: [],
            save_loading: false,
            choice_is_empty: false,
            is_error: false,
            permission_is_denied: false,

            filter_examen: '',
            filtered_examens: [],
            exm_is_loading: true,
            exm_is_empty: false,

            types_examens: []
        }
    },

    watch: {
        filter_examen() {
            this.filterExamen()
        },

        one_is_checked() {
            this.choice_is_empty = false
        },

        refresh_state() {
            if (this.selected_slug == 'examen') {
                this.fetchExamen()
            }
        }
    },

    computed: {
        
    },

    mounted() {
        
    },

    methods: {
        fetchExamen() {
            this.exm_is_loading = true
            mod_examen.getExamens().then((types_examens) => {
                this.types_examens = types_examens
                if (this.types_examens.length == 0) {
                    this.exm_is_empty = true
                } else {
                    this.exm_is_empty = false
                    this.filtered_examens = this.types_examens
                }

                this.exm_is_loading = false
            }).catch(() => {
                this.exm_is_loading = false
                this.is_error = true
            })
        },

        hadleUndefinedPrice() {
            this.warningToast("Le prix de cet examen n'a pas été défini !")
        },

        submit() {
            if (this.one_is_checked.length == 0) {
                this.choice_is_empty = true
                return;
            }

            this.one_is_checked = this.setPrestationUID(this.one_is_checked)

            let data = {
                user_id: this.user_id,
                patient_id: this.info_patient.id,
                prestations: this.one_is_checked,
                type_prestation: 'Examens',
                data_type: 'examen',
                proforma_id: this.proforma_id,
                is_proforma: this.is_proforma,
                can_add_differential_computing: this.can_add_differential_computing.response,
                can_set_pac: this.can_set_pac,
                info_caissier: this.info_caissier,
                info_patient: {
                    nom_patient: this.info_patient.nom,
                    sexe: (this.info_patient.sexe == 'Masculin')?'H':'F',
                    telephone: this.info_patient.telephone_mobile,
                    num_dossier: this.info_patient.num_dossier,
                    age: this.info_patient.age
                },
                format_ref_facture: this.format_ref_facture
            }

            this.save_loading = true
            mod_prestation.getTarifPrestation(data).then((response) => {
                data = Object.assign(data, response)
                
                this.$store.dispatch('saveVentePrestation', data).then((response) => {
                    if (response.success) {
                        this.successToast('Ajout effectué avec succès')
                        this.$emit('emitPrestation', response.fpro_id)

                        this.one_is_checked = []
                        this.$refs.fpro_exm.click()

                        if (response.fpro_id > 0) {
                            this.$router.push({ path: '/ventes/facture-proforma/'+response.fpro_id })
                        }
                    } else {
                        this.$refs.fpro_exm.click()
                        this.dangerToast(response.message)
                    }

                    this.save_loading = false
                }).catch(() => {
                    this.save_loading = false
                    this.$refs.fpro_exm.click()
                    this.dangerToast('Une erreur est survenue lors de l\'enregistrement. Veuillez réessayer plus tard.')
                })
            }).catch(() => {
                this.save_loading = false
                this.$refs.fpro_exm.click()
                this.dangerToast('Une erreur est survenue lors du calcul des tarifs. Veuillez réessayer plus tard.')
            })

            
        },

        filterExamen() {
            this.filtered_examens = [];

            if (this.filter_examen == '') {
                this.filtered_examens = this.types_examens
            } else {
                this.types_examens.forEach(examen => {
                    let cleaned_examen = this.removeAccents(examen.nom)
                    let cleaned_filter = this.removeAccents(this.filter_examen)

                    if (cleaned_examen.toLowerCase().includes(cleaned_filter.toLowerCase())) {
                        this.filtered_examens.push(examen)
                    }
                });
            }
        },
    }
}


